import { createRouter, createWebHistory } from "vue-router"

const Listing = ()=> import(/* webpackChunkName: "Listing" */'@/views/Listing.vue')
const Landing = ()=> import(/* webpackChunkName: "landing" */'@/views/Landing.vue')
const Destiny = ()=> import(/* webpackChunkName: "microsite-destiny" */'@/views/microsites/destiny/Destiny.vue')
const BoseBlitz = ()=> import(/* webpackChunkName: "microsite-boseeBlitz" */'@/views/microsites/bossBlitz/BossBlitz.vue')
const Ignition = ()=> import(/* webpackChunkName: "microsite-ignition" */'@/views/microsites/ignition/Ignition.vue')

const routes = [
  {
    path: "/",
    component: Listing
  },
  {
    path: "/landing",
    component: Landing
  },
  {
    path: "/micro-site/destiny",
    component: Destiny,
  },
  {
    path: "/micro-site/bossblitz",
    component: BoseBlitz,
  },
  {
    path: "/micro-site/ignition",
    component: Ignition,
  },
]

const router = createRouter({
    history : createWebHistory(),
    base:"/",
    routes
})

export {
  router,
  routes
};
